import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FiltersComponent } from '../filters/filters.component';
import { GetCatalogCategoryAttributesResponse as Attribute } from '@medindex-webapi';
import { AsyncPipe, NgIf } from '@angular/common';
import { CategoriesButtonComponent } from '../categories-button/categories-button.component';
import { OverscrollYDirective } from '@shared/directives/overscroll/y-overscroll';
import { ButtonResetFiltersComponent } from '../button-reset-filters/button-reset-filters.component';

@Component({
  selector: 'app-catalog-sider',
  templateUrl: './catalog-sider.component.html',
  styleUrls: ['./catalog-sider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FiltersComponent,
    NgIf,
    CategoriesButtonComponent,
    AsyncPipe,
    OverscrollYDirective,
    ButtonResetFiltersComponent,
  ],
})
export class CatalogSiderComponent {
  @Input() attributes: Attribute[] | undefined;
  @Input() isDesktop = false;
}
